// extracted by mini-css-extract-plugin
export default {"container":"j2N6d_","image":"kTRsOG"};